import { render, staticRenderFns } from "./QuestionCriteriaListComponent.vue?vue&type=template&id=43886afe"
import script from "./QuestionCriteriaListComponent.vue?vue&type=script&lang=js"
export * from "./QuestionCriteriaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports